import React, { FC } from 'react'
import StyledCard from './styles'
import { CardProps } from 'antd'

const RCardPrimary: FC<CardProps> = ({ children, ...props }) => {
  return <StyledCard {...props}>{children}</StyledCard>
}

export default RCardPrimary
